import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { X, Cookie } from "lucide-react";

const KEY = "jcboutik_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] border-t border-slate-200 bg-white/95 backdrop-blur-xl shadow-[0_-8px_30px_rgba(0,0,0,0.08)]"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 px-4 py-5 md:flex-row md:items-center md:px-6">
        <Cookie className="h-8 w-8 flex-shrink-0 text-blue-600" />
        <p className="flex-1 text-sm text-slate-600">
          Nous utilisons des cookies pour améliorer votre expérience, mémoriser votre panier et analyser le trafic.
          En poursuivant, vous acceptez notre utilisation des cookies. <a href="/mentions-legales" className="font-semibold text-blue-700 hover:underline">En savoir plus</a>.
        </p>
        <div className="flex gap-3">
          <Button variant="outline" onClick={() => decide("refused")} data-testid="cookie-refuse" className="rounded-full">
            Refuser
          </Button>
          <Button onClick={() => decide("accepted")} data-testid="cookie-accept" className="rounded-full bg-blue-600 text-white hover:bg-blue-700">
            Tout accepter
          </Button>
        </div>
        <button onClick={() => decide("dismissed")} className="absolute right-3 top-3 text-slate-400 hover:text-slate-600 md:hidden">
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
